import { useFormikContext } from "formik";

function CheckBox({ label, disabled, name }) {
  const { setFieldValue, values } = useFormikContext();

  // Extract current checked value from Formik state
  const checked = !!values?.general?.[name];

  const handleChange = (e) => {
    setFieldValue(`general.${name}`, e.target.checked);
  };

  return (
    <div className="flex flex-row w-full items-center gap-2 py-3 rounded-lg bg-[var(--alert-management-variable-bg)]">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        className="custom-checkbox form-check-input ml-[3px]"
      />
      <label className="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)]">
        {label}
      </label>
    </div>
  );
}

export default CheckBox;
